// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2656 ? "23e5971a" : chunkId) + "." + {"2656":"251e676baf88c003","3829":"1009b9da801313d9"}[chunkId] + ".js";
};